import { useState, useContext, useEffect } from 'react';
import { FiEdit2 } from "react-icons/fi";
import { FaSpinner } from "react-icons/fa"
import { TiTick } from "react-icons/ti";
import { GrFormClose } from "react-icons/gr";
import { FaFileDownload, FaFileUpload } from "react-icons/fa";
import { RiShieldUserFill } from "react-icons/ri";
import { MdCreateNewFolder } from "react-icons/md";
import { SiListmonk } from "react-icons/si";
import { IoIosCreate } from "react-icons/io";
import email from '../../assets/CandidateProfile/Header_Email.svg'
import contact from '../../assets/CandidateProfile/Header_Contact.svg'
import address from '../../assets/CandidateProfile/Header_Location.svg'
import resume from '../../assets/CandidateProfile/Header_Resume.svg'
import dollar from "../../assets/CandidateProfile/Header_Rupees.svg"


import { DataProvider } from '../../store/ContextProvider';
import Overview from '../../components/Candidate Info/Overview';
import { renderImgSrc } from '../../utils/renderImgSrc';
import { useLocation, useNavigate } from 'react-router-dom';
import Experience from './Experience';
import Education from './Education';
import EmployerEntry from './EmployerEntry';
import Skills from './Skills/Skills';
import Highlights from './Highlights/Highlights';

export default function Profiles({ candidate }) {

    // Destructure for display
    const { _id, applicantID, candidateID, applicantName, applicantFullName, emailAddress, phoneNumber, profileSummary, currentCTC, resumeAvailable, resumeLink, experiences, presentAddress, experience = {} } = candidate || {};

    const navigate = useNavigate()
    const location = useLocation()
    const { currentUser, BeURL, showAlert } = useContext(DataProvider);
    const [currentHeader, setCurrentHeader] = useState(location.state?.active || "Overview")
    const [endpoint, setEndpoint] = useState(null);
    const [displayFilename, setDisplayFilename] = useState("");
    const [loadingView, setLoadingView] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [summary, setSummary] = useState("")
    const [summaryUpdateStatus, setSummaryUpdateStatus] = useState(false)
    const [summaryLoading, setSummaryLoading] = useState(false)

    useEffect(() => {
        if (profileSummary) {
            setSummary(profileSummary)
        }
    }, [profileSummary])

    const handleSummaryUpdate = () => {
        if (summaryLoading) return
        if (!summary || summary.length < 10) {
            showAlert("Enter atleast 10 characters for Summary updation")
            return
        }
        setSummaryLoading(true)
        setSummaryUpdateStatus(false)
        fetch(`${BeURL}/update-candidate-summary`, {
            credentials: "include",
            method: 'post',
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({ summary })
        })
            .then(res => res.json())
            .then(data => {
                setSummaryLoading(false)
                alert(data.message)
            })
            .catch((err) => {
                setSummaryLoading(false)
                console.log("Error in updating candidate summary:", err)
                alert("Trouble in connecting to the Server! please try again later.")
            })
    }

    const handleSummaryReset = () => {
        setSummaryUpdateStatus(false)
        setSummary(profileSummary)
    }

    const tempApplicantFullName = applicantName ? applicantName : "Candidate"



    // build the base name once:
    const safeName = (tempApplicantFullName).replace(
        /[<>:"/\\|?*.]/g,
        ""
    );
    const expLabel =
        experience.year || experience.month
            ? `[${experience.year || 0}y ${experience.month || 0}m]`
            : "[_Resume]";
    const baseName = `SAN_${safeName}${expLabel}`;

    useEffect(() => {
        if (BeURL && (applicantID || _id)) {
            setEndpoint(`${BeURL}/resume/${_id || applicantID}`);
            if (resumeAvailable && resumeLink) {
                const extMatch = resumeLink.match(/\.(\w+)$/);
                const ext = extMatch ? `.${extMatch[1]}` : ".pdf";
                setDisplayFilename(`${baseName}${ext}`);
            } else {
                setDisplayFilename(`${baseName}.pdf`);
            }
        }
    }, [BeURL, applicantID, _id, resumeAvailable, resumeLink]);

    // View inline if PDF, otherwise download
    const handleView = async () => {
        if (loadingView) return;
        setLoadingView(true);
        try {
            const res = await fetch(`${endpoint}?download=0`, {
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Server ${res.status}`);

            const contentType = res.headers.get("content-type") || "";
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);

            if (contentType.includes("pdf")) {
                window.open(blobUrl, "_blank");
            } else {
                // fallback: directly download non-PDFs
                const cd = res.headers.get("content-disposition") || "";
                const fnMatch = cd.match(/filename\*?=?[^']*'?'?([^;"]+)/i);
                const filename = fnMatch
                    ? decodeURIComponent(fnMatch[1])
                    : displayFilename;
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
        } catch (err) {
            console.error("View failed:", err);
            alert("Could not load resume for viewing.");
        } finally {
            setLoadingView(false);
        }
    };

    // Always download, using server-sent filename
    const handleDownload = async () => {
        if (loadingDownload) return;
        setLoadingDownload(true);
        try {
            const res = await fetch(`${endpoint}?download=1`, {
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Server ${res.status}`);

            const blob = await res.blob();
            const cd = res.headers.get("content-disposition") || "";
            const fnStar = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
            const fnQuoted = cd.match(/filename\s*=\s*"([^"]+)"/i);
            const fnUnquoted = cd.match(/filename\s*=\s*([^;]+)/i);
            let filename;
            if (fnStar) filename = decodeURIComponent(fnStar[1]);
            else if (fnQuoted) filename = fnQuoted[1];
            else if (fnUnquoted) filename = fnUnquoted[1].trim();
            else filename = displayFilename;

            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
        } catch (err) {
            console.error("Download failed:", err);
            alert("Could not download resume.");
        } finally {
            setLoadingDownload(false);
        }
    };

    const handleResumeUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("resume", file);

        const res = await fetch(`${BeURL}/upload-candidate-resume/${candidate._id}`, {
            method: "POST",
            credentials: "include",
            body: formData
        });
        const data = await res.json();
        showAlert(data.message);
        if (data.success) {
            window.location.reload();

        }
    };

    const formatNames = values => {
        if (values) {
            return values?.split(/[_-\s]/)?.map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');
        }
        else return " - "
    }
    const renderOwnerCard = (title, data, Icon, date) => {
        if (data) {
            return (
                <div className='flex flex-1 gap-3 items-center shadow-[0_0_6px_#bcbfd0] rounded-xl py-2 px-3'>
                    <Icon className='text-primary-400 text-4xl' />
                    <div className='text-[13px] pr-3'>
                        <h4 className='text-slate-600 text-xs'>{title}</h4>
                        <p className='text-black font-medium mt-1'>{data || "N/A"}</p>
                        {date && <span className='text-xs'>{new Date(date).toLocaleDateString("en-GB")}</span>}
                    </div>
                </div>
            )
        }
        return null
    }

    if (!endpoint) {
        return (
            <div className="p-3 rounded border my-2 bg-slate-100">Loading...</div>
        );
    }

    // Format the address:
    const formatAddress = (address) => {
        let formattedAddress = ''

        if (address && typeof address === 'object' && Object.entries(address).length > 0) {

            if (address.addressLine1) {
                formattedAddress += address.addressLine1

            }
            if (address.addressLine2) {
                formattedAddress += `, ${address.addressLine2}`
            }
            if (address.city) {
                formattedAddress += `, ${address.city}`
            }
            if (address.district) {
                formattedAddress += `, ${address.district}`
            }
            if (address.state) {
                formattedAddress += `, ${address.state}`
            }
            if (address.country) {
                formattedAddress += `, ${address.country}`
            }
            if (address.zipCode) {
                formattedAddress += ` - ${address.zipCode}`
            }

            return formattedAddress
        }
        else return null
    }

    return (
        <main className=' '>
            <div className="w-full  min-h-[750px] py-3 px-1 ">

                <div className='md:p-2 my-2'>
                    {currentUser.role === 'job-seeker' ?
                        <div className='flex justify-end'>
                            <button className='flex gap-2 justify-center items-center text-sm py-1 rounded-lg my-2 px-3 hover:bg-slate-50 text-primary-300 cursor-pointer bg-white border-primary-300 border-[0.5px]' onClick={() => navigate(`/update-account/skills?inverse=${true}&userId=${candidate._id}`, { state: { from: location.pathname } })}> <FiEdit2 />  Update profile</button>
                        </div>
                        :
                        (<div className='flex justify-end px-1 md:gap-4 gap-1 text-slate-600 my-2 text-xs'>
                            <p className='font-medium'>Created At  : {new Date(candidate?.createdAt).toLocaleString("en-GB")}</p>
                            <p className='font-medium'>Updated At : {new Date(candidate?.updatedAt).toLocaleString("en-GB")}</p>
                            <p className='font-medium'>Views : {candidate?.resumeViewCount || 0}</p>
                            <p className='font-medium'>Downloads : {candidate?.resumeDownloadCount || 0}</p>
                        </div>)

                    }

                    {/* Start of Header */}
                    <div className="p-3 md:p-4 md:py-6 shadow-[0_0_8px_#e0e0e0] rounded-xl bg-white">
                        <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-6">

                            <div className="px-4 flex flex-col items-center lg:items-start">
                                <img
                                    className="h-20 md:h-40 rounded-full object-cover aspect-square border"
                                    src={renderImgSrc(candidate?.profilePicLink, candidate?.applicantFullName || candidate?.applicantName)}
                                    alt="profile"
                                />
                                {currentUser.role !== 'job-seeker' && <span className="bg-white text-xs text-primary-300 px-4 py-1 rounded-md font-medium mt-2 md:mt-4">
                                    {applicantID ? `ApplicantID: ${applicantID}` : `CandidateID: ${candidateID}`}
                                </span>}
                            </div>

                            <div className="flex-1 text-slate-800 w-full">

                                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                                    <div className='w-full text-center lg:text-left'>
                                        <h3 className="font-semibold lg:text-xl text-black">{applicantName || applicantFullName}</h3>
                                        <p className="text-sm lg:text-md text-[#3D3D3D]">{formatNames(experiences?.[0]?.jobTitle)}</p>
                                        <p className="text-sm lg:text-md text-blue-600 bg-blue-50 rounded font-medium px-3 py-1 w-fit my-1 mx-auto lg:mx-0">{experience?.year ? `${experience.year + 'y '}` : ""}{experience?.month ? `${experience.month + 'm'}` : ""}</p>
                                    </div>

                                    <div className="flex flex-wrap justify-center gap-2 w-full">

                                        <button className={`flex items-center bg-primary-300 font-medium text-sm md:text-md rounded-lg gap-2 text-white px-4 py-2 
              ${loadingDownload ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                                            onClick={handleDownload} aria-disabled={loadingDownload} title="Download Resume">
                                            {loadingDownload ? (
                                                <FaSpinner className="animate-spin text-xl" />
                                            ) : (

                                                <FaFileDownload className='text-xl' />

                                            )}<p>Download Resume</p>
                                        </button>
                                        {currentUser.role !== 'job-seeker' &&
                                            < button className="flex items-center text-white font-medium text-sm md:text-md rounded-lg gap-2 bg-primary-400 px-4 py-2"
                                                onClick={() => document.getElementById("resumeInput").click()}>
                                                <FaFileUpload className='text-xl' />
                                                <input id="resumeInput" type="file" hidden onChange={handleResumeUpload} />
                                                <p>Upload Resume</p>
                                            </button>}
                                    </div>
                                </div>


                                <div className="flex flex-wrap gap-3 lg:gap-6 items-center my-2 lg:my-3">
                                    {[
                                        { icon: email, label: "Primary Email", value: emailAddress },
                                        { icon: contact, label: "Primary Contact", value: phoneNumber?.number },
                                        { icon: dollar, label: "Current CTC", value: currentCTC.amount },
                                        {
                                            icon: address,
                                            label: "Present Address",
                                            value: formatAddress(presentAddress) || "",
                                        },
                                    ].map((val, idx) => (
                                        <div key={idx} className="flex items-start gap-3  p-3 px-4 rounded-lg bg-[#F8F9FF]">
                                            <img src={val.icon} alt={val.label} />
                                            <div>
                                                <p className="text-sm text-gray-500">{val.label}</p>
                                                <p className="text-sm font-medium">{val.value || "-"}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <div className="flex flex-col lg:flex-row justify-start items-start lg:items-center gap-3 lg:gap-6 mt-3 lg:mt-5">

                                    <div className="w-full lg:w-1/2 bg-gradient-to-tr from-[#F4F4FC] to-[#F9F3FC] rounded-lg py-3 px-4">
                                        <div className="flex justify-between items-center mb-2">
                                            <p className="text-sm text-gray-500">{currentUser.role === 'employer' ? 'Profile Score' : 'Profile Completed'}</p>
                                            <p className="text-primary-500 text-sm font-medium">{candidate?.score}%</p>
                                        </div>
                                        <div className="w-full bg-[#C8C4CD] rounded-full h-2 relative">
                                            <div
                                                className="bg-[#030213] h-2 rounded-full transition-all duration-500"
                                                style={{ width: `${candidate?.score}%` }}
                                            ></div>
                                        </div>
                                        {currentUser.role === "job-seeker" && <p className='text-xs text-slate-600 mt-1'>Complete your profile to increase visibility to recruiters</p>}
                                    </div>

                                    <div className={`flex items-center gap-3 p-3 px-4 bg-[#F8F9FF] rounded-lg w-full lg:w-auto 
              ${loadingView || loadingDownload ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                                        aria-disabled={displayFilename.endsWith(".pdf") ? !!loadingView : !!loadingDownload}
                                        onClick={displayFilename.endsWith(".pdf") ? handleView : handleDownload}
                                    >
                                        {loadingView || loadingDownload
                                            ? <FaSpinner className="animate-spin text-xl" />
                                            : <img src={resume} className="h-8 w-8" alt="resume" />
                                        }
                                        <div>
                                            <p className="text-base font-medium inline-block">Resume {
                                                currentUser.role !== 'job-seeker' ? (candidate.newResumeStatus
                                                    && (<sup className="  text-xs font-semibold bg-white px-1 text-secondary-300 rounded" title={`${candidate.newResumeUploadOn ? (new Date(candidate.newResumeUploadOn).toLocaleDateString("en-GB")) : ""}`}>new</sup>
                                                    )) : (null)
                                            }
                                            </p>

                                            <p className="text-sm lg:text-md text-gray-500">{displayFilename}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Header */}

                    <div className='p-2 md:p-4 md:py-6  bg-white my-6 rounded-xl shadow '>
                        <div className='flex justify-between '>
                            <h5 className='font-medium text-primary-400'> Profile Summary</h5>
                            {currentUser.role === 'job-seeker' && (
                                <div>
                                    {
                                        summaryUpdateStatus ?
                                            <div className={`flex gap-2 items-center ${summaryLoading && 'opacity-60'}`}>
                                                <GrFormClose className={`text-primary-300 font-medium text-xl ${summaryLoading ? "cursor-not-allowed" : "cursor-pointer"}`} onClick={handleSummaryReset} />
                                                <TiTick className={`text-primary-300 font-medium text-xl ${summaryLoading ? "cursor-not-allowed" : "cursor-pointer"}`} onClick={handleSummaryUpdate} />
                                            </div>
                                            : <FiEdit2 className='text-primary-300 font-medium' onClick={() => setSummaryUpdateStatus(true)} />
                                    }
                                </div>
                            )}
                        </div>
                        <textarea value={summary || 'No data available'} onChange={e => setSummary(e.target.value)} readOnly={currentUser.role !== 'job-seeker' && !summaryUpdateStatus}
                            className={`text-black border leading-normal first-letter:pl-7 p-3 w-full mt-2 rounded-lg text-sm lg:text-md`}
                            rows={summary ? 3 : 1} />

                    </div>

                    {/* Start of Tab Header */}
                    <div className='p-2 bg-white my-2 md:my-6 rounded-xl shadow overflow-x-auto'>
                        <div className='flex justify-evenly gap-4 sm:gap-6 items-start font-medium text-slate-800 bg-[#ECECF0] p-1 rounded-lg min-w-fit'>
                            {
                                ['Overview', 'Skills', 'Experience', 'Education', 'Highlights'].map((header, i) => (
                                    <span key={i} className={` cursor-pointer text-sm md:text-md px-3 md:px-6 lg:px-10 py-2 rounded-lg sha ${currentHeader === header ? ' bg-[#ECF1FF] text-primary-300' : ''}`} onClick={() => setCurrentHeader(header)}>{header}</span>
                                ))
                            }
                        </div>
                    </div>

                    {/* End of Tab Header */}

                    <>
                        {currentHeader === "Overview" && <Overview currentUser={currentUser} candidate={candidate} setCurrentHeader={setCurrentHeader} />}
                        {currentHeader === "Skills" && <Skills candidate={candidate} currentUser={currentUser} />}
                        {currentHeader === "Experience" && <Experience candidate={candidate} currentUser={currentUser} />}
                        {currentHeader === "Education" && <Education candidate={candidate} currentUser={currentUser} />}
                        {currentHeader === "Highlights" && <Highlights candidate={candidate} currentUser={currentUser} />}


                        {
                            currentUser.role !== 'job-seeker' && (candidate.applicantID) &&
                            <>
                                <h3 className='font-semibold my-3 lg:my-6 text-center'>Ownership</h3>
                                <div className='flex justify-center flex-wrap gap-3 lg:gap-6 my-3'>
                                    {renderOwnerCard("Ownership", candidate.ownership, RiShieldUserFill)}
                                    {renderOwnerCard("Applicant status", candidate.applicantStatus, SiListmonk)}
                                    {renderOwnerCard("Created by", candidate.createdBy, MdCreateNewFolder, candidate.createdDate)}
                                    {renderOwnerCard("Updated by", candidate.updatedBy, IoIosCreate, candidate.updatedOn)}
                                </div>
                            </>
                        }

                        {
                            ["employer", "admin"].includes(currentUser.role) && <EmployerEntry candidate={candidate || {}} />
                        }


                    </>



                </div>
            </div>
        </main >
    );
}